import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { z as classNames } from './utils2.js';

const mapyReviewPhotoItemCss = ":host{display:block}.mapy-review-photo-item{display:flex;width:100%;height:72px;box-sizing:border-box;position:relative;border-radius:8px;overflow:hidden}.delete-btn{position:absolute;left:4px;top:4px;background:rgba(0, 0, 0, 0.6);border-radius:100%;cursor:pointer;z-index:5;padding:3px;border:none}.delete-btn svg{fill:#fff;width:16px;height:16px;display:block}.overlay{position:absolute;left:0;top:0;right:0;bottom:0;background:rgba(255, 255, 255, 0.75);z-index:4}.overlay.rejected{left:0 !important;background:rgba(216, 56, 56, 0.8)}.image-cont{position:absolute;left:0;top:0;right:0;bottom:0;z-index:3;overflow:hidden}.icon-warn-filled{position:absolute;right:10px;bottom:11px;fill:rgba(255, 255, 255, 0.7);width:20px;height:20px;z-index:4}.image-cont img{width:100%;height:100%;object-fit:cover}";
const MapyReviewPhotoItemStyle0 = mapyReviewPhotoItemCss;

const MapyReviewPhotoItem = /*@__PURE__*/ proxyCustomElement(class MapyReviewPhotoItem extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.photoDelete = createEvent(this, "photoDelete", 1);
        this.onClick = (event) => {
            event.stopPropagation();
            event.preventDefault();
            this.photoDelete.emit({});
        };
        this.src = "";
        this.percent = 100;
        this.rejected = false;
    }
    render() {
        return (h(Host, { key: 'b7facd50406e25373e03c6b825c1646dc13c76c0' }, h("div", { key: 'f643740412edd1c1526c8646d993e919a587d61b', class: "mapy-review-photo-item" }, h("button", { key: 'f6c46a47c701627778e94fd8f51c941565a6114f', type: "button", class: "delete-btn", onClick: this.onClick }, h("svg", { key: '79fa121796189708640c6841e3e756fe21a256a7', x: "0px", y: "0px", viewBox: "0 0 16 16", class: "icon icon-delete" }, h("g", { key: 'bf00e522ca94b90b36f5bce623e48477015851b6' }, h("path", { key: 'a96b6637fd8f066195cdd9ff149c4e883ec6ca5d', d: "M4,12.7C4,13.4,4.6,14,5.3,14h5.3c0.7,0,1.3-0.6,1.3-1.3v-8H4L4,12.7L4,12.7z M12.6,2.7h-2.3L9.6,2H6.3L5.6,2.7H3.3V4h9.3 V2.7z" })))), h("span", { key: 'cc3d375a187dfd20effb05582ce64fc3ded28368', class: classNames(["overlay", this.rejected ? "rejected" : ""]), style: { left: `${this.percent}%` } }), h("span", { key: 'ead72f41797bcd7fe1420fa446fbf055a5ea042f', class: "image-cont" }, h("img", { key: 'f710bbaf210c04d99799ff5fdafc3aa68352ff56', src: this.src, alt: "" })), this.rejected && h("svg", { key: '3996eb9ebd1b3a011b54f4a06cbb8d965a3d9c1f', class: "icon-warn-filled", viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '2a0e0d4d434065cb0f2390be607f12933f684acf', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M9.12589 0.573439C9.50689 -0.11237 10.4932 -0.112371 10.8742 0.573439L19.1747 15.5143C19.545 16.1808 19.063 17 18.3005 17H1.69956C0.937074 17 0.455106 16.1808 0.825401 15.5143L9.12589 0.573439ZM11 15H9.00004V13H11V15ZM9.00004 11H11V4.99996H9.00004V11Z" })))));
    }
    static get style() { return MapyReviewPhotoItemStyle0; }
}, [1, "mapy-review-photo-item", {
        "src": [513],
        "percent": [514],
        "rejected": [516]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["mapy-review-photo-item"];
    components.forEach(tagName => { switch (tagName) {
        case "mapy-review-photo-item":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, MapyReviewPhotoItem);
            }
            break;
    } });
}
defineCustomElement();

export { MapyReviewPhotoItem as M, defineCustomElement as d };

//# sourceMappingURL=mapy-review-photo-item2.js.map